class Pagination {
    constructor(querySelector) {
        const elem = () => document.querySelector(querySelector)

        /**
         * Initialize pagination functionality
         * Handles both cases: DOM already loaded or still loading
         */
        const initPagination = () => {
            if (!elem()) {
                return;
            }

            const loadMoreButton = elem().querySelector('[data-load-more]');
            const productGrid = elem().querySelector(`[data-product-grid]`);
            const paginationContainer = elem().querySelector(`[data-pagination-container]`);
            const paginationInfo = elem().querySelector(`[data-pagination-info]`);
            const loadingSpinner = elem().querySelector(`[data-loading-spinner]`);

            if (!loadMoreButton || !productGrid || !paginationContainer) {
                // If essential elements aren't found, exit
                return;
            }

            loadMoreButton.addEventListener('click', function () {
                const nextUrl = this.dataset.nextUrl;
                if (!nextUrl) {
                    return; // Exit if no URL
                }

                // Show loading state
                this.style.display = 'none'; // Hide button
                if (loadingSpinner) loadingSpinner.style.display = 'inline-block'; // Show spinner

                // Fetch the next page's content *for this section only*
                fetch(`${nextUrl}`)
                    .then((response) => {
                        if (!response.ok) {
                            throw new Error(`HTTP error! status: ${response.status}`);
                        }
                        return response.text();
                    })
                    .then((text) => {
                        // Use DOMParser to safely parse the fetched HTML
                        const parser = new DOMParser();
                        const htmlDocument = parser.parseFromString(text, 'text/html');

                        // Find the product grid and pagination container in the fetched HTML
                        const newProductGrid = htmlDocument.querySelector(`${querySelector} [data-product-grid]`);
                        const newPaginationContainer = htmlDocument.querySelector(`${querySelector} [data-pagination-container]`);

                        if (newProductGrid) {
                            // Append new product/promo cards to the existing grid
                            // Using spread syntax (...) to convert NodeList to array for appending
                            productGrid.append(...newProductGrid.childNodes);
                        } else {
                            console.error('Load More: Could not find new product grid in fetched content.');
                        }

                        // Update pagination info (progress bar and text)
                        const newPaginationInfo = newPaginationContainer?.querySelector(`[data-pagination-info]`);
                        if (newPaginationInfo && paginationInfo) {
                            paginationInfo.innerHTML = newPaginationInfo.innerHTML; // Replace old info with new
                        }

                        // Check if there's a "Load More" button in the new pagination data
                        const newLoadMoreButton = newPaginationContainer?.querySelector(`[data-load-more]`);

                        if (newLoadMoreButton) {
                            // Update the button's URL and make it visible again
                            this.dataset.nextUrl = newLoadMoreButton.dataset.nextUrl;
                            this.style.display = 'inline-block'; // Show button again
                        } else {
                            // No more pages, remove the button and its container
                            const actionsContainer = elem().querySelector(`[data-pagination-actions]`);
                            if (actionsContainer) {
                                actionsContainer.remove();
                            }
                        }
                    })
                    .catch((error) => {
                        console.error('Error loading more products:', error);
                        this.style.display = 'inline-block'; // Show button again on error
                        // Optionally display an error message to the user
                    })
                    .finally(() => {
                        // Hide loading state regardless of success or error
                        if (loadingSpinner) loadingSpinner.style.display = 'none';
                    });
            });
        };

        // Check if DOM is already loaded
        if (document.readyState === 'loading') {
            // DOM is still loading, wait for DOMContentLoaded
            document.addEventListener('DOMContentLoaded', initPagination);
        } else {
            // DOM is already loaded, initialize immediately
            initPagination();
        }
    }
}